import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) =>
	state.api.network.dns.domain.nameserver.updateRegisteredIP;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_DOMAIN_NAMESERVER_UPDATEREGISTEREDIP',
	method: 'POST',
	url: '/network/dns/domain/nameserver/updateRegisteredIP.json',
});

export { actions, reducer, sagas, selectors };
